import { Subheading } from '../typography';
import Button from '../button';
import { Check } from '../svg';
import { colors } from '../foundation';
import { motion } from 'framer-motion';
import clsx from 'clsx';

type Props = {
  index: number;
  buttonlayoutId?: string;
  label: string;
  selected?: boolean;
  variant?: 'default' | 'flat';
  buttonLabelClasses?: string;
  buttonClasses?: string;
  onClick: (index: number) => void;
};

const Tab = ({
  index,
  label,
  buttonlayoutId,
  selected = false,
  variant = 'default',
  onClick,
  buttonLabelClasses = '',
  buttonClasses = '',
}: Props) => {
  return (
    <>
      {variant !== 'flat' ? (
        <div className="relative w-full">
          {buttonlayoutId && selected && (
            <motion.div
              layoutId={`${buttonlayoutId}-layoutButton`}
              transition={{ duration: 0.2 }}
              className="absolute top-0 h-full w-full rounded-full bg-button-primary-default"
            ></motion.div>
          )}
          <Button
            label={label}
            variant={selected ? (buttonlayoutId ? 'float' : 'primary') : 'text'}
            classes={clsx(buttonClasses, 'w-full')}
            labelClasses={clsx(buttonLabelClasses, '!font-medium')}
            icon={selected ? <Check color={colors.primary.white} size={32} /> : null}
            onClick={() => onClick(index)}
          />
        </div>
      ) : (
        <motion.button
          tabIndex={0}
          id={`Tab-${index}`}
          onClick={() => onClick(index)}
          className={
            `${selected ? 'border-red-100' : 'border-red-25'} ` +
            `w-full cursor-pointer border-b-1 text-center  hover:border-red-100`
          }
        >
          <Subheading small={false} classes={`mx-4 text-center ${selected ? 'text-red-100' : 'text-black-100'} py-8`}>
            {label}
          </Subheading>
        </motion.button>
      )}
    </>
  );
};
export default Tab;
